<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Сторис</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="pl-3 pb-3" />
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                class="col-form-label"
                                sm="3">
                                Активен
                            </CCol>
                            <CCol sm="9">
                                <CSwitch
                                    class=""
                                    color="success"
                                    shape="pill"
                                    variant="opposite"
                                    :checked.sync="stories.enabled" />
                            </CCol>
                        </CRow>

                        <CInput
                            v-model="stories.title"
                            horizontal
                            label="Название"
                            placeholder="Введите название сторис"/>

                        <CInput
                            v-model="stories.show_time"
                            horizontal
                            label="Время показа (милисекунды)"
                            placeholder="Введите время показа (милисекунды)" />

                        <CInput
                            v-model="stories.button_name"
                            horizontal
                            label="Название кнопки"
                            placeholder="Введите название кнопки"/>

                        <CInput
                            v-model="stories.color_button"
                            horizontal
                            label="Цвет кнопки (Например: #FFFFFF)"
                            placeholder="Введите цвет кнопки (Например: #FFFFFF)"/>

                        <CInput
                            v-model="stories.link"
                            horizontal
                            label="Ссылка"
                            placeholder="Введите ссылку на страницу, которая будет открываться при клике кнопку"/>
                        <CInputFile
                            ref="picture"
                            label="Изображение"
                            horizontal
                            @change="selectPicture"/>

                        <CRow class="pl-3">
                            <table class="table">
                                <draggable v-model="images" tag="tbody">
                                    <tr v-for="image in images" :key="image.name">
                                        <td><CIcon
                                            :height="24"
                                            :content="$options.icons.cilCursorMove"
                                            class="handle" /></td>
                                        <td>{{ image.name }}</td>
                                        <td><CButton @click="removeImage(image.name)"><CIcon :content="$options.icons.cilTrash" class="handle" /></CButton></td>
                                    </tr>
                                </draggable>
                            </table>
                        </CRow>
                    </CForm>

                </CCardBody>

                <CCardFooter>
                    <CButton
                        color="primary"
                        class="mr-3"
                        @click="save"
                    >Сохранить</CButton>
                    <CButton
                        color="light"
                        class="mr-3"
                        @click="goBack"
                    >Отмена</CButton>
                </CCardFooter>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import draggable from 'vuedraggable';
    import { cilCursorMove, cilTrash } from '@coreui/icons';

    export default {

        name: 'CreateStories',

        components: {
            draggable
        },

        icons: {
            cilCursorMove,
            cilTrash
        },

        data: () => ({
            stories: {
                id: null,
                title: '',
                show_time: '',
                button_name: '',
                color_button: '',
                link: '',
                enabled: false,
                pictures: [],
            },
            images: [],
            isCreated: false,
        }),

        methods: {
            selectPicture(FileList) {
                this.images.push(FileList[0]);
            },
            async save() {
                try {
                    if (this.images.length > 5) {
                        this.$root.$emit('showError', 'Максимальное количество изображений 5');
                        return;
                    }
                    if(this.images.length === 0) {
                        this.$root.$emit('showError', 'Добавьте изображения');
                        return;
                    }
                    if (!this.stories.title){
                        this.$root.$emit('showError', 'Введите название сторис');
                    }

                    if(this.images) {
                        for (const picture of this.images) {
                            let formData = new FormData();
                            formData.append('file', picture);
                            const squarePictureName = await this.axios.post('/files/upload', formData);
                            this.stories.pictures.push(squarePictureName.data.filename);
                        }
                    }

                    this.stories.show_time = +this.stories.show_time;
                    await this.axios.post(`/stories/${this.stories.id}`,this.stories);

                    this.goBack();
                } catch (error) {
                    console.log(error);
                    this.$root.$emit('showError', 'Ошибка сохранения.');
                }
            },

            goBack() {
                this.$router.push({ path: `/stories` });
            },

            removeImage(name) {
                this.images = this.images.filter(image => image.name !== name);
            }
        },
    };
</script>
<style>
</style>
